<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head">
				<div class="modal__head__title">How would you like to Pay?</div>
            	<div class="modal__head__subtitle">Our bank details are also shown on your quote.</div>
			</div>
            <div class="modal__content">
                <p>Payment Ref : <strong>{{quoteReference}}</strong></p>
                <p>Our Bank : <strong>Natwest</strong></p>
                <p>Account Number : <strong>76777766</strong></p>
                <p>Sort Code : <strong>51-70-06</strong></p>
				<br />	
				<button class="btn" @click="emitSendBacsPaymentConfirm">Confirm BACS Transfer has been sent</button>
            </div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		props : ['quoteReference'],
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'PayByBacsModal',
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		},
		methods : {
            emitSendBacsPaymentConfirm(){
                 this.$emit('sendBacsPaymentConfirm');
                this.$store.commit('openModal', '');
            }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/PayByBacsModal.vue